module.exports = __webpack_public_path__ + "assets/img/input_up.38928d38.png";